// Enter.jsx
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../hodoremp.css";
import {
  CreateAttendEmpAction,
  GetAllAtendEmpAction,
} from "../../../../redux/actions/EmployeePageAction";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import notify from "../../../Notifcation";

// Leaflet Icon Fix
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const Enter = ({ userData }) => {
  const dispatch = useDispatch();
  const All = useSelector((state) => state.EmployeePageR.GetATTENDEMP);

  const currentTime = new Date();
  const [Lat, setLat] = useState();
  const [Lon, setLon] = useState();
  const [Datee, setDate] = useState(currentTime.toLocaleDateString("en-GB"));
  const [Timee, setTimee] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [notes, setNotes] = useState("");
  const [lastCheckinCoords, setLastCheckinCoords] = useState(null);
  const [lastCheckoutCoords, setLastCheckoutCoords] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isCheckedIn, setIsCheckedIn] = useState(false);
  const [isCheckedOut, setIsCheckedOut] = useState(false);

  const PageSize = 7;

  useEffect(() => {
    dispatch(GetAllAtendEmpAction());
  }, [dispatch]);

  const onPress = async (page) => {
    await dispatch(
      GetAllAtendEmpAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
useEffect(() => {
  if (All?.data?.length > 0) {
    const lastRecord = All.data[0]; // افترض أن البيانات مرتبة من الأحدث للأقدم
    if (lastRecord.attendanceType === "Presence") {
      setIsCheckedIn(true);  // يمنع الضغط على حضور
      setIsCheckedOut(false); // يسمح بالانصراف
      setLastCheckinCoords(lastRecord.coordinates);
    } else if (lastRecord.attendanceType === "Departure") {
      setIsCheckedIn(false); // يسمح بالحضور
      setIsCheckedOut(true); // يمنع الضغط على انصراف
      setLastCheckoutCoords(lastRecord.coordinates);
    }
  } else {
    setIsCheckedIn(false);
    setIsCheckedOut(false);
  }
}, [All]);

  const getFormattedTime = () => {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;
  };

  const formatTo12Hour = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${minutes} ${ampm}`;
  };

  const handleCheckin = async () => {
    setIsPress(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("Date", currentTime.toISOString().split("T")[0]);
    formData.append("Time", getFormattedTime());
    formData.append("AttendanceType", "Presence");
    formData.append("Coordinates", `${Lat} - ${Lon}`);
    formData.append("Note", notes);
    formData.append("employeeId", userData.id);

    await dispatch(CreateAttendEmpAction(formData));
    setIsPress(false);
    setLoading(false);

    setIsCheckedIn(true);   // بعد الحضور ديسابل حضور
    setIsCheckedOut(false); // يسمح بالانصراف
  };

  const handleCheckout = async () => {
    setIsPress(true);
    setLoading(true);

    const formData = new FormData();
    formData.append("Date", currentTime.toISOString().split("T")[0]);
    formData.append("Time", getFormattedTime());
    formData.append("AttendanceType", "Departure");
    formData.append("Coordinates", `${Lat} - ${Lon}`);
    formData.append("Note", notes);
    formData.append("EmployeeId", userData.id);

    await dispatch(CreateAttendEmpAction(formData));
    setIsPress(false);
    setLoading(false);

    setIsCheckedIn(false);  // يسمح بالحضور تاني
    setIsCheckedOut(true);  // ديسابل انصراف لحد الحضور القادم
  };

  const handleShowMapIn = () => {
    if (!lastCheckinCoords) return;
    const [lat, lon] = lastCheckinCoords.split(" - ").map((c) => c.trim());
    window.location.href = `https://www.google.com/maps?q=${lat},${lon}`;
  };

  const handleShowMapOut = () => {
    if (!lastCheckoutCoords) return;
    const [lat, lon] = lastCheckoutCoords.split(" - ").map((c) => c.trim());
    window.location.href = `https://www.google.com/maps?q=${lat},${lon}`;
  };

  useEffect(() => {
    setTimee(getFormattedTime());
  }, []);

  useEffect(() => {
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      if (result.state === "granted" || result.state === "prompt") {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setCurrentLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
            setLat(position.coords.latitude);
            setLon(position.coords.longitude);
          },
          (error) => {
            alert("تعذر تحديد الموقع: " + error.message);
          }
        );
      } else {
        alert("من فضلك قم بتفعيل الوصول إلى موقعك");
      }
    });
  }, []);

  const res = useSelector((state) => state.EmployeePageR.AddATTENDEMP);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.responseMessage ===
              "Great, attendance created Successfully"
          ) {
            dispatch(GetAllAtendEmpAction(`PageSize=${PageSize}`));
            notify("تم تسجيل البيانات بنجاح", "success");
          } else if (
            res.data &&
            res.data.responseMessage ===
              "sorry, this user have an exist attendance todayPresence"
          ) {
            notify("لقد تم اثبات الحضور من قبل ", "warn");
          } else if (
            res.data &&
            res.data.responseMessage ===
              "sorry, you can't add request of type Departure"
          ) {
            notify("لقد تم اثبات الانصراف من قبل  ", "warn");
          } 
           else if (
            res.data &&
            res.data.responseMessage ===
             "sorry, Departure time must be after Presence time"

          ) {
            notify(" يجب اثبات الحضوراولاً ثم اثبات الانصراف", "warn");
          }
          else notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [loading, res, dispatch]);

  return (
    <Container>
      <div className="inputs-container">
        <div className="inp-container">
          <TextField
            label={"التاريخ"}
            variant="outlined"
            type="text"
            focused
            value={Datee}
          />
        </div>
        <div className="inp-container">
          <TextField
            label="التوقيت"
            variant="outlined"
            value={Timee}
            focused
          />
        </div>
        <div className="inp-container">
          <TextField
            label="الإحداثيات"
            variant="outlined"
            value={
              Lat === undefined || Lon === undefined
                ? "برجاء تفعيل الموقع"
                : `${Lat} - ${Lon}`
            }
          />
        </div>
        <div className="inp-container">
          <TextField
            label="ملاحظات"
            variant="outlined"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
      </div>

      <div className="check-container">
        <button
          className="checkin"
          onClick={handleCheckin}
          disabled={isCheckedIn}
          style={isCheckedIn ? {backgroundColor: '#cccccc', color: '#666666', cursor: 'not-allowed'} : {}}
          
        >
          حضور <i className="fa-solid fa-user-check"></i>
        </button>
        <button
          className="checkout"
          onClick={handleCheckout}
          disabled={isCheckedOut}
                    style={isCheckedOut ? {backgroundColor: '#cccccc', color: '#666666', cursor: 'not-allowed'} : {}}
        >
          انصراف <i className="fa-solid fa-door-open"></i>
        </button>
      </div>

      <Table id="my-table" className="maint" responsive striped bordered hover>
        <thead>
          <tr>
            <th>التاريخ <i className="fa-solid fa-hashtag"></i></th>
            <th>الوقت <i className="fa-solid fa-hashtag"></i></th>
            <th>الاحداثيات <i className="fa-regular fa-calendar-check"></i></th>
            <th>الحالة <i className="fa-solid fa-hashtag"></i></th>
            <th>ملاحظات <i className="fa-solid fa-hashtag"></i></th>
          </tr>
        </thead>
        <tbody>
          {All?.data?.length > 0
            ? All.data.map((item, idx) => (
                <tr key={idx}>
                  <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                  <td>{formatTo12Hour(item.time)}</td>
                  <td>
                    {item.coordinates && item.coordinates !== "undefined - undefined" ? (
                      <a
                        href={`https://www.google.com/maps?q=${item.coordinates.replace(" - ", ",")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        شاهد الخريطة <i className="fa-solid fa-map-location-dot"></i>
                      </a>
                    ) : (
                      <><span>لا توجد إحداثيات</span><i className="fa-solid fa-map-location-dot"></i></>
                    )}
                  </td>
                  <td>
                    {item.attendanceType === "Presence"
                      ? "حضور"
                      : item.attendanceType === "Departure"
                      ? "انصراف"
                      : ""}
                  </td>
                  <td>{item.note}</td>
                </tr>
              ))
            : null}
        </tbody>
      </Table>

      <ToastContainer autoClose={1200} />
      <Pagination
        onPress={onPress}
        PageSize={PageSize}
        PageCount={All ? All.totalPages : null}
      />
    </Container>
  );
};

export default Enter;
